import { useCallback, useEffect, useRef, useState } from 'react';

import { fetch_close_switch } from '../api';
import { read_failed_data } from './adapters';

/*
 * the month-close switch as the shell holds it: read on mount, re-read on demand (a Needs
 * attention reload, a stale toggle), replaced by a toggle's answer.
 */
const useCloseSwitch = () => {
  const [data, setData] = useState(null);
  // Only the newest read lands, so a slow read never overwrites a toggle's answer.
  const seq = useRef(0);

  const reload = useCallback(() => {
    seq.current += 1;
    const mine = seq.current;
    fetch_close_switch()
      .then((d) => {
        if (mine === seq.current) setData(d);
      })
      .catch((e) => {
        if (mine !== seq.current) return;
        // Never keep a stale ON/OFF on screen: show the switch as unknown instead.
        console.error('month-close switch read failed', e?.response?.status || e?.message);
        setData(read_failed_data(e));
      });
  }, []);

  const replace = useCallback((d) => {
    seq.current += 1;
    setData(d);
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { data, reload, replace };
};

export default useCloseSwitch;
